<template>
  <b-card title="Lead Management">
    <lead-filter @filtersUpdated="filtersChangeHandler" />
    <lead-list :filters="filters" />
  </b-card>
</template>

<script>
import {
  BCard,
} from 'bootstrap-vue'
import LeadFilter from '@/components/Sales/LeadManagement/LeadFilter.vue'
import LeadList from '@/components/Sales/LeadManagement/LeadList.vue'

export default {
  components: {
    BCard,
    LeadFilter,
    LeadList,
  },
  data() {
    return {
      filters: {},
    }
  },
  methods: {
    filtersChangeHandler(filterData) {
      this.filters = filterData
    },
  },
}
</script>
